export const CardList = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      className="bi bi-card-list"
      viewBox="0 0 16 16"
    >
      <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" />
      <path d="M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8m0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" />
    </svg>
  );
};

export const Plus = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-plus"
      viewBox="0 0 16 16"
    >
      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
    </svg>
  );
};

export const HMenu = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      role="img"
    >
      <title>Menu</title>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M4 7h22M4 15h22M4 23h22"
      ></path>
    </svg>
  );
};
export const ApplicationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 128 128"
      viewBox="0 0 128 128"
      width="20"
      height="20"
    >
      <path
        fill="currentColor"
        d="M68.8,44.9c-0.2-1-0.8-1.9-1.7-2.3c-3-1.5-9.5-3.7-9.5-3.7v-2.2l0.2-0.1c1.3-0.9,2.1-2.4,2.4-4l0-0.2h0.2
		c1,0,1.9-0.6,2.2-1.5c0.2-0.4,0.3-0.8,0.3-1.3c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.2-0.6-0.5-0.8l-0.6-0.4l0.1-0.7
		c1.1-4.7-2.6-9-7.5-9.1c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.4,0c-4.9,0.1-8.6,4.4-7.5,9.1l0.1,0.7L45.6,28c-0.2,0.2-0.4,0.5-0.5,0.8
		C45,29,45,29.3,45,29.6c0,0.5,0.1,0.9,0.3,1.3c0.4,0.9,1.2,1.5,2.2,1.5h0.2l0,0.2c0.3,1.6,1.1,3,2.4,4l0.2,0.1v2.2
		c0,0-6.5,2.2-9.5,3.7c-0.9,0.5-1.5,1.3-1.7,2.3c-0.5,3-0.6,8-0.6,8H54h15.5C69.4,52.8,69.3,47.8,68.8,44.9z"
      ></path>
      <path
        fill="currentColor"
        d="M96.9,94v22.7c0,0.3-0.2,0.5-0.5,0.5H11.5c-0.3,0-0.5-0.2-0.5-0.5V11.3c0-0.3,0.2-0.5,0.5-0.5h84.9
		c0.3,0,0.5,0.2,0.5,0.5V44l7.8-10.6c0.2-0.2,0.4-0.5,0.6-0.7V11.3c0-4.9-4-8.9-8.9-8.9H11.5c-4.9,0-8.9,4-8.9,8.9v105.4
		c0,4.9,4,8.9,8.9,8.9h84.9c4.9,0,8.9-4,8.9-8.9V82.9L98,92.7C97.7,93.2,97.3,93.6,96.9,94z"
      ></path>
      <path
        fill="currentColor"
        d="M66.5 93.8H44.4c-1 0-1.9.8-1.9 1.9 0 1 .8 1.9 1.9 1.9h22.1c1 0 1.9-.8 1.9-1.9C68.4 94.7 67.6 93.8 66.5 93.8zM66.5 80.8H23.4c-1 0-1.9.8-1.9 1.9 0 1 .8 1.9 1.9 1.9h43.1c1 0 1.9-.8 1.9-1.9C68.4 81.6 67.6 80.8 66.5 80.8zM66.5 67.7H23.4c-1 0-1.9.8-1.9 1.9s.8 1.9 1.9 1.9h43.1c1 0 1.9-.8 1.9-1.9S67.6 67.7 66.5 67.7zM121.8 35.3c-1.9-1.4-4.1-1.9-6.4-1.6-2.3.3-4.3 1.6-5.7 3.4L79.1 78.7c-.2.2-.3.5-.4.8l-3.6 16c-.2.8.1 1.6.8 2.1.3.2.6.3 1 .4.4 0 .9 0 1.3-.3l14.2-8.2c.2-.1.5-.3.6-.6l30.7-41.6C126.5 43.5 125.7 38.1 121.8 35.3zM81.4 91.1l-.9-.9 1.5-6.8 5.5 4.1L81.4 91.1z"
      ></path>
    </svg>
  );
};

export const CategoriesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M5.28808 2.5C5.08458 2.5 4.90489 2.62879 4.83789 2.82129L4.36621 4.19238H2.80273C2.59873 4.19238 2.41706 4.3231 2.35156 4.5166C2.28656 4.7101 2.35215 4.92435 2.51465 5.04785L3.78222 6.00879L3.35254 7.38184C3.29104 7.57884 3.36372 7.79311 3.53222 7.91211C3.70072 8.03161 3.92777 8.02927 4.09277 7.90527L5.28808 7.00977L6.4834 7.90527C6.5679 7.96827 6.66805 8 6.76855 8C6.86505 8 6.96144 7.97061 7.04394 7.91211C7.21244 7.79311 7.28513 7.57884 7.22363 7.38184L6.79492 6.00879L8.06152 5.04785C8.22452 4.92435 8.29011 4.70963 8.22461 4.51562C8.15961 4.32213 7.97794 4.19238 7.77344 4.19238H6.20996L5.73828 2.82129C5.67228 2.62929 5.49158 2.5 5.28808 2.5ZM10.25 4.5C10.1506 4.49859 10.0519 4.51696 9.95972 4.55402C9.86749 4.59108 9.78355 4.6461 9.71277 4.71588C9.64199 4.78566 9.58579 4.86882 9.54743 4.96051C9.50907 5.0522 9.48932 5.15061 9.48932 5.25C9.48932 5.34939 9.50907 5.4478 9.54743 5.53949C9.58579 5.63118 9.64199 5.71434 9.71277 5.78412C9.78355 5.8539 9.86749 5.90892 9.95972 5.94598C10.0519 5.98304 10.1506 6.00141 10.25 6H20.75C20.8494 6.00141 20.9481 5.98304 21.0403 5.94598C21.1325 5.90892 21.2164 5.8539 21.2872 5.78412C21.358 5.71434 21.4142 5.63118 21.4526 5.53949C21.4909 5.4478 21.5107 5.34939 21.5107 5.25C21.5107 5.15061 21.4909 5.0522 21.4526 4.96051C21.4142 4.86882 21.358 4.78566 21.2872 4.71588C21.2164 4.6461 21.1325 4.59108 21.0403 4.55402C20.9481 4.51696 20.8494 4.49859 20.75 4.5H10.25ZM5.28808 9.25098C5.08508 9.25098 4.90389 9.37929 4.83789 9.57129L4.36719 10.9424H2.80273C2.59873 10.9424 2.41706 11.0731 2.35156 11.2666C2.28656 11.4601 2.35262 11.6744 2.51562 11.7979L3.78222 12.7588L3.35351 14.1318C3.29201 14.3288 3.3647 14.5431 3.5332 14.6621C3.7017 14.7816 3.92777 14.7793 4.09277 14.6553L5.28808 13.7598L6.48437 14.6553C6.56887 14.7183 6.66903 14.75 6.76953 14.75C6.86553 14.75 6.96144 14.7206 7.04394 14.6621C7.21244 14.5431 7.28513 14.3288 7.22363 14.1318L6.79492 12.7588L8.06152 11.7979C8.22452 11.6744 8.28963 11.4601 8.22363 11.2666C8.15863 11.0731 7.97794 10.9424 7.77344 10.9424H6.20898L5.73828 9.57129C5.67228 9.37929 5.49158 9.25098 5.28808 9.25098ZM10.25 11.25C10.1506 11.2486 10.0519 11.267 9.95972 11.304C9.86749 11.3411 9.78355 11.3961 9.71277 11.4659C9.64199 11.5357 9.58579 11.6188 9.54743 11.7105C9.50907 11.8022 9.48932 11.9006 9.48932 12C9.48932 12.0994 9.50907 12.1978 9.54743 12.2895C9.58579 12.3812 9.64199 12.4643 9.71277 12.5341C9.78355 12.6039 9.86749 12.6589 9.95972 12.696C10.0519 12.733 10.1506 12.7514 10.25 12.75H20.75C20.8494 12.7514 20.9481 12.733 21.0403 12.696C21.1325 12.6589 21.2164 12.6039 21.2872 12.5341C21.358 12.4643 21.4142 12.3812 21.4526 12.2895C21.4909 12.1978 21.5107 12.0994 21.5107 12C21.5107 11.9006 21.4909 11.8022 21.4526 11.7105C21.4142 11.6188 21.358 11.5357 21.2872 11.4659C21.2164 11.3961 21.1325 11.3411 21.0403 11.304C20.9481 11.267 20.8494 11.2486 20.75 11.25H10.25ZM5.28808 16C5.08458 16 4.90489 16.1288 4.83789 16.3213L4.36621 17.6924H2.80273C2.59873 17.6924 2.41706 17.8231 2.35156 18.0166C2.28656 18.2101 2.35165 18.4244 2.51465 18.5479L3.78222 19.5088L3.35254 20.8818C3.29104 21.0788 3.36372 21.2931 3.53222 21.4121C3.70072 21.5316 3.92777 21.5293 4.09277 21.4053L5.28808 20.5098L6.4834 21.4053C6.5679 21.4683 6.66805 21.5 6.76855 21.5C6.86505 21.5 6.96144 21.4706 7.04394 21.4121C7.21244 21.2931 7.28513 21.0788 7.22363 20.8818L6.79492 19.5088L8.06152 18.5479C8.22452 18.4244 8.29011 18.2096 8.22461 18.0156C8.15961 17.8221 7.97794 17.6924 7.77344 17.6924H6.20996L5.73828 16.3213C5.67228 16.1293 5.49158 16 5.28808 16ZM10.25 18C10.1506 17.9986 10.0519 18.017 9.95972 18.054C9.86749 18.0911 9.78355 18.1461 9.71277 18.2159C9.64199 18.2857 9.58579 18.3688 9.54743 18.4605C9.50907 18.5522 9.48932 18.6506 9.48932 18.75C9.48932 18.8494 9.50907 18.9478 9.54743 19.0395C9.58579 19.1312 9.64199 19.2143 9.71277 19.2841C9.78355 19.3539 9.86749 19.4089 9.95972 19.446C10.0519 19.483 10.1506 19.5014 10.25 19.5H20.75C20.8494 19.5014 20.9481 19.483 21.0403 19.446C21.1325 19.4089 21.2164 19.3539 21.2872 19.2841C21.358 19.2143 21.4142 19.1312 21.4526 19.0395C21.4909 18.9478 21.5107 18.8494 21.5107 18.75C21.5107 18.6506 21.4909 18.5522 21.4526 18.4605C21.4142 18.3688 21.358 18.2857 21.2872 18.2159C21.2164 18.1461 21.1325 18.0911 21.0403 18.054C20.9481 18.017 20.8494 17.9986 20.75 18H10.25Z" />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      className="-mt-1"
      width="20"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      id="download"
    >
      <path
        fill="currentColor"
        d="M15.43,24.82l-10-7,1.14-1.64L15,22.08V2h2V22.08l8.43-5.9,1.14,1.64-10,7a1,1,0,0,1-1.14,0ZM28,23v4a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V23H2v4a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3V23Z"
        data-name="35 Download, Arrow, Essential"
      ></path>
    </svg>
  );
};
export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z"
      />
    </svg>
  );
};
export const ViewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        color="currentColor"
      >
        <path d="M21.544 11.045c.304.426.456.64.456.955c0 .316-.152.529-.456.955C20.178 14.871 16.689 19 12 19c-4.69 0-8.178-4.13-9.544-6.045C2.152 12.529 2 12.315 2 12c0-.316.152-.529.456-.955C3.822 9.129 7.311 5 12 5c4.69 0 8.178 4.13 9.544 6.045" />
        <path d="M15 12a3 3 0 1 0-6 0a3 3 0 0 0 6 0" />
      </g>
    </svg>
  );
};
export const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M21 12a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1m-15 .76V17a1 1 0 0 0 1 1h4.24a1 1 0 0 0 .71-.29l6.92-6.93L21.71 8a1 1 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83l-6.94 6.93a1 1 0 0 0-.29.71m10.76-8.35l2.83 2.83l-1.42 1.42l-2.83-2.83ZM8 13.17l5.93-5.93l2.83 2.83L10.83 16H8Z"
      />
    </svg>
  );
};
